"use client"

import dynamic from "next/dynamic"
import type { ChatLauncherProps } from "./chat-launcher"

const ChatLauncher = dynamic(
  () =>
    import("./chat-launcher").then((m) => ({
      default: m.ChatLauncher,
    })),
  { ssr: false }
)

export function ChatLauncherLazy(props: ChatLauncherProps) {
  return <ChatLauncher {...props} />
}
